import { render, staticRenderFns } from "./SwitchParametros.vue?vue&type=template&id=11b3d3ac"
import script from "./SwitchParametros.vue?vue&type=script&lang=js"
export * from "./SwitchParametros.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports